import types from '../types';

/**
 * @param {types.VideoCard[] | types.DocumentsListingGroup[] | types.NewsCard[] | types.LocationCard[] | types.TradeShowCard[]} items
 * @param {types.Pagination} pagination
 * @returns {boolean}
 */
const shouldShowPagination = (items, pagination) => {
    if (
        !items ||
        !Array.isArray(items) ||
        !items.length ||
        !pagination ||
        !pagination.currentPage ||
        !pagination.pagesCount ||
        !pagination.rowsCount ||
        !pagination.rowsOnPage
    ) {
        return false;
    }

    return true;
};

export default shouldShowPagination;
